import { PureComponent, lazy } from 'react';
import { Grid, CircularProgress, Typography } from '@mui/material';
import { getFirebase } from '@client/firebase';
import { setFirebaseInstance } from '@client/slices/helpers/clients.reducer';
import { startScaffoldingUser } from '@client/slices/helpers/session.reducer';
import { Modal } from '@client/components/globals/Modal';
import { Spacer } from '@client/components/common/Spacer';
import { Loader } from '@client/components/common/Loader';
import { AllUsersListeners } from './AllUsersListeners';

const AdminListenersLoader = lazy(() => import('./AdminListeners'));
const SignedInListenersLoader = lazy(() => import('./SignedInListeners'));
const SignedOutListenersLoader = lazy(() => import('./SignedOutListeners'));

export class EventWatcher extends PureComponent {
  componentDidMount() {
    const { dispatch } = this.props;

    const firebase = getFirebase({
      onAuthStateChanged: this.onAuthStateChanged,
    });

    dispatch(setFirebaseInstance(firebase));
  }

  componentDidUpdate({
    pathname: prevLocation,
    logoutPending: prevLogoutPending,
    impersonationPending: prevImpersonationPending,
  }) {
    const {
      pathname, logoutPending, impersonationPending,
    } = this.props;

    if (logoutPending !== prevLogoutPending && logoutPending === true) {
      Modal.show({
        buttons: [],
        disableBackdropClick: true,
        body: (
          <div className="spacer">
            <Spacer />

            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CircularProgress />
              </Grid>

              <Grid item>
                <Typography variant="h3">
                  Logging out...
                </Typography>
              </Grid>
            </Grid>
          </div>
        ),
      });
    } else if (logoutPending !== prevLogoutPending && logoutPending === false) {
      Modal.hide();
    }

    if (impersonationPending !== prevImpersonationPending && impersonationPending === true) {
      Modal.show({
        buttons: [],
        disableBackdropClick: true,
        maxWidth: 'md',
        body: (
          <div className="spacer">
            <Spacer />

            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CircularProgress />
              </Grid>

              <Grid item>
                <Typography variant="h3">
                  Toggling Impersonation...
                </Typography>
              </Grid>
            </Grid>
          </div>
        ),
      });
    } else if (impersonationPending !== prevImpersonationPending && impersonationPending === false) {
      Modal.hide();
    }

    if (pathname !== prevLocation) {
      window.scrollTo(0, 0);
    }
  }

  componentWillUnmount() {
    window.Stripe = null;
  }

  onAuthStateChanged = (authUser) => {
    const { dispatch } = this.props;

    dispatch(startScaffoldingUser(authUser));
  };

  render() {
    const { userState, isAdmin } = this.props;

    return (
      <>
        <AllUsersListeners />

        {userState ? (
          <>
            {Boolean(isAdmin) && (
              <Loader load={AdminListenersLoader} />
            )}

            <Loader load={SignedInListenersLoader} />
          </>
        ) : (
          <Loader load={SignedOutListenersLoader} />
        )}
      </>
    );
  }
}
